import { Container } from "./styles";

export function InformationDashboard(){
    return (   
        <Container>
          
        </Container>
    )
}